import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { API, graphqlOperation } from 'aws-amplify';
import { createRoadMapItems, updateRoadMapItems, deleteRoadMapItems } from '../graphql/mutations';
import { listRoadMapItems } from '../graphql/queries';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6),
    },
  },
  textField: {
    margin: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  submitButton: {
    margin: theme.spacing(3, 0),
  },
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginTop: '32px',
    backgroundColor: '#f9f9f9'
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem'
  },
  actionButton: {
    color: '#01b5e2',
    borderColor: '#01b5e2',
    '&:hover': {
      backgroundColor: '#01b5e2',
      color: 'white',
    }
  }
}));

const AddRoadmapItemForm = () => {
  const classes = useStyles();
  const [text, setText] = useState('');
  const [description, setDescription] = useState('');
  const [editingRoadmapId, setEditingRoadmapId] = useState(null);
  const [roadmapItems, setRoadmapItems] = useState([]);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  useEffect(() => {
    fetchRoadmapItems();
  }, []);

  const fetchRoadmapItems = async () => {
    const response = await API.graphql(graphqlOperation(listRoadMapItems));
    setRoadmapItems(response.data.listRoadMapItems.items);
  };

  const handleDelete = async () => {
    await API.graphql(graphqlOperation(deleteRoadMapItems, { input: { id: deleteTargetId } }));
    setDeleteDialogOpen(false);
    setDeleteTargetId(null);
    fetchRoadmapItems();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();


    if (editingRoadmapId) {
        await API.graphql(
          graphqlOperation(updateRoadMapItems, {
            input: {
              id: editingRoadmapId,
              text: text,
              description: description
            },
          })
        );
    } else {
      await API.graphql(
        graphqlOperation(createRoadMapItems, {
          input: {
            text: text,
            description: description,
          },
        })
      );
    }

    setDescription('');
    setText('');
    setEditingRoadmapId(null);
    fetchRoadmapItems();
  };

  const handleEdit = (roadMapID) => {
    const roadMapItem = roadmapItems.find((item) => item.id === roadMapID);
    if (roadMapItem) {
      setText(roadMapItem.text);
      setDescription(roadMapItem.description);
    }
  };

  const handleCancelEdit = () => {
    setText('');
    setDescription('');
    setEditingRoadmapId(null);
  };


  return (
    <div>
      <Box className={classes.root} component="form" onSubmit={handleSubmit}>
        <Typography variant="h4" component="h1" gutterBottom>
          Add Output Item
        </Typography>
        <TextField
          className={classes.textField}
          required
          label="Guidance Action"
          value={text}
          onChange={(event) => setText(event.target.value)}
        />
        <TextField
          className={classes.textField}
          label="Description (optional)"
          multiline
          minRows={4}
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
        
        <Button type="submit" variant="contained" color="primary">
          {editingRoadmapId ? 'Update' : 'Submit'}
        </Button>
        {editingRoadmapId && (
          <Button variant="outlined" color="secondary" onClick={handleCancelEdit} style={{ marginTop: '10px' }}>
            Cancel
          </Button>
        )}
      </Box>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell className={classes.tableCell}>Text</TableCell>
              <TableCell className={classes.tableCell}>Description</TableCell>
              <TableCell className={classes.tableCell}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roadmapItems.map((roadMapItem) => (
              <TableRow key={roadMapItem.id} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{roadMapItem.text}</TableCell>
                <TableCell className={classes.tableCell}>{roadMapItem.description}</TableCell>
                <TableCell className={classes.tableCell}>
                  <Button variant="outlined" className={classes.actionButton} onClick={() => handleEdit(roadMapItem.id)}>Edit</Button>
                  <Button variant="outlined" className={classes.actionButton} onClick={() => { setDeleteDialogOpen(true); setDeleteTargetId(roadMapItem.id); }}>Delete</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Road Map Item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddRoadmapItemForm;
